import React from 'react';

import { Button, Typography } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalErrorMessage from '../ModalErrorMessage/ModalErrorMessage';

import './ErrorMessageCell.less';

interface ErrorMessageCellProps {
  message: string;
  title?: string;
}

function ErrorMessageCell({
  message,
  title,
}: ErrorMessageCellProps): React.ReactElement {
  const modal = useModal();

  return (
    <div className="errorMessageCell">
      <Typography.Paragraph
        ellipsis={{ rows: 1 }}
        className="error-text"
        aria-label="Message d'erreur, éventuellement tronqué"
        tabIndex={0}
      >
        {message}
      </Typography.Paragraph>

      <Button
        type="link"
        size="small"
        onClick={modal.open}
        className="show-error-btn"
        aria-label="Afficher le message d'erreur complet"
      >
        Afficher l&apos;erreur
      </Button>

      <ModalErrorMessage
        visible={modal.visible}
        close={modal.close}
        errorMessage={message}
        title={title}
      />
    </div>
  );
}

export default ErrorMessageCell;
